import { Api } from 'helper/api/base';
import { getAccessToken } from 'helper/auth';

export class ApiClient {
  api: Api;
  auth: string;
  method: string;

  constructor(api: Api, auth: string) {
    this.api = api;
    this.auth = auth;
  }

  get(url: string, params = {}) {
    return this.generateHeaders().then((headers: Headers) => {
      return this.api.get(url, { headers, params });
    });
  }

  postWithFormData(url: string, formData: FormData) {
    this.method = 'oauth+form';

    return this.post(url, formData);
  }

  post(url: string, body = {}) {
    return this.generateHeaders().then((headers) => {
      return this.api.post(url, { headers, body });
    });
  }

  patch(url: string, body = {}) {
    return this.generateHeaders().then((headers) => {
      return this.api.patch(url, { headers, body });
    });
  }

  delete(url: string, body = {}) {
    return this.generateHeaders().then((headers) => {
      return this.api.delete(url, { headers, body });
    });
  }

  withBasicAuth() {
    this.method = 'basic';
    return this;
  }

  withOAuth() {
    this.method = 'oauth';
    return this;
  }

  withoutAuth() {
    this.method = 'none';
    return this;
  }

  private generateHeaders() {
    return new Promise((resolve, reject) => {
      switch (this.method) {
        case 'basic':
          resolve(new Headers({
            'Accept': 'application/json',
            'Authorization': `Basic ${this.auth}`,
            'Content-Type': 'application/x-www-form-urlencoded'
          }));
          return;
        case 'oauth':
          getAccessToken().then((token) => {
            resolve(new Headers({
              'Accept': 'application/json',
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }));
          })
          .catch((e) => reject(e));
          return;
        case 'oauth+form':
          getAccessToken().then((token) => {
            resolve(new Headers({
              Accept: 'application/json',
              Authorization: `Bearer ${token}`
            }));
          })
          .catch((e) => reject(e));
          return;
        case 'none':
        default:
          resolve(new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/api/client.ts